<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">All Customize-Trading Pricing</h5>
                <p class="mb-0 text-sm">
                  Below the list of Pricing.
                </p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <a
                    href="/pricings/customize-trading/new"
                    class="mb-0 btn bg-gradient-success btn-sm me-2"
                    target="_blank"
                    >+&nbsp; Add New</a
                  >
                  <button
                    type="button"
                    class="mx-1 mb-0 btn btn-outline-success btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#import"
                    v-if="false"
                  >
                    Import
                  </button>
                  <div
                    id="import"
                    class="modal fade"
                    tabindex="-1"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog mt-lg-10">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 id="ModalLabel" class="modal-title">
                            Import CSV
                          </h5>
                          <i class="fas fa-upload ms-3"></i>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">
                          <p>You can browse your computer for a file.</p>
                          <input
                            type="text"
                            placeholder="Browse file..."
                            class="mb-3 form-control"
                          />
                          <div class="form-check">
                            <input
                              id="importCheck"
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              checked=""
                            />
                            <label
                              class="custom-control-label"
                              for="importCheck"
                              >I accept the terms and conditions</label
                            >
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn bg-gradient-secondary btn-sm"
                            data-bs-dismiss="modal"
                          >
                            Close
                          </button>
                          <button
                            type="button"
                            class="btn bg-gradient-success btn-sm"
                          >
                            Upload
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    class="mt-1 mb-0 btn btn-outline-success btn-sm export mt-sm-0"
                    data-type="csv"
                    type="button"
                    name="button"
                    v-if="false"
                  >
                    Export
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive" style="overflow-x: scroll;">
              <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns search-results">
                <div class="dataTable-top">
                  <div class="dataTable-dropdown">
                    <label>
                      <select class="dataTable-selector form-select form-select-sm" v-model="limitPerPage" @change="getAllAPI()">
                        <option v-for="item in perPages" :value="item" :key="item" >{{ item }}</option>                        
                      </select>
                      entries per page
                    </label>
                    </div>
                    <div class="dataTable-search">
                      <input class="dataTable-input" placeholder="Search..." type="text" v-model="search" @change="getAllAPI()">
                    </div>
                  </div>
                  <div class="dataTable-container">
                    <table id="products-list" class="table table-flush dataTable-table">
                      <thead class="thead-light">
                        <tr>
                          <th>
                            No. 
                          </th>
                          <th>
                            Product Name
                          </th>
                          <th>
                            Price
                          </th>
                          <th>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(record, index) in records" :key="record.id">
                          <td class="text-sm">{{ index+1 }}</td>
                          <td class="text-sm">{{ record.service_name }}</td>
                          <td class="text-sm">Rp.{{ record.pricing_models[0].base_price }}</td>                          
                          <td class="text-sm">
                            <a :href="'/pricings/customize-trading/'+ record.id +'/edit'" class="mx-3" data-bs-toggle="tooltip" data-bs-original-title="Edit user">
                              <i class="fas fa-user-edit text-secondary" aria-hidden="true"></i>
                            </a>
                            <a href="javascript:;" @click="confirmationDelete(record.id)" data-bs-toggle="tooltip" data-bs-original-title="Delete user">
                              <i class="fas fa-trash text-secondary" aria-hidden="true"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="dataTable-bottom">
                    <div class="dataTable-info">Showing {{ totalRecords == 0 ? 0 : currentPage }} to {{ shownData() }} of {{  totalRecords }} entries</div>
                      <nav class="dataTable-pagination">
                        <argon-pagination color="success" size="sm">
                          <argon-pagination-item prev v-if="currentPage > 1" @click="onChangePagination(currentPage-1)"/>
                          <argon-pagination-item v-for="item in dataPerPages()" :label="String(item)" :active="item == currentPage" :key="item" @click="onChangePagination(item)"/>
                          <argon-pagination-item next v-if="currentPage < dataPerPages()" @click="onChangePagination(currentPage+1)"/>
                        </argon-pagination>
                      </nav>
                    </div>
                 
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import PricingsService from "@/services/pricings.service.js";
  import ArgonPagination from "@/components/ArgonPagination.vue";
  import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
  import showSwalConfirmationDelete from "@/mixins/showSwal.js";
  import { ref } from 'vue';
  import { toast } from 'vue3-toastify';

  const toastId = ref('');

  const moment = require('moment');

  export default {
    name: "UserList",
    data() {
      return {
        perPages: [5, 10, 15, 20, 25],
        records: [],
        totalRecords: 0,        
        limitPerPage: 5,
        currentPage: 1,
        search: ''
      };
    },
    mixins: [showSwalConfirmationDelete],
    methods: {
      getPriceModels(pricing_models) {
        const minUnit = Math.min(...pricing_models.map(o => o.base_price))
        const maxUnit = Math.max(...pricing_models.map(o => o.base_price))
        return `Rp${minUnit} - Rp${maxUnit}`
      },
      getPricingUnit(pricing_models) {
        const minUnit = Math.min(...pricing_models.map(o => o.min_unit))
        const maxUnit = Math.max(...pricing_models.map(o => o.max_unit))
        return `${minUnit} - ${maxUnit}`
      },
      showLoading(){
        toastId.value = toast.loading('Please wait...');
      },
      hideLoading(){
        setTimeout(() => {
          toast.remove(toastId.value)
        }, 1000); 
      },
      showSuccess(){
        toast.update(toastId.value, {
          render: "delete Successfully",
          closeOnClick: true,
          closeButton: true,
          type: 'success',
          isLoading: false,
          autoClose: 3000
        });      
      },
      showFailed(e){
        toast.update(toastId.value, {
          render: e,
          closeOnClick: true,
          closeButton: true,
          type: 'error',
          isLoading: false,
          autoClose: 3000
        });
      },
      confirmationDelete(id){
        this.showSwalConfirmationDelete().then((result) => {
            console.log(result)
            if (result.value) {
              this.deleteRecord(id)
            }
          });
      },
      deleteRecord(id){
        this.showLoading()

        PricingsService.delete(id).then(() => {
          this.showSuccess()
          this.getAllAPI()
        }).catch(e => {
          this.showFailed(e.response.data.code_message)           
        });
      },
      dateTime(value) {
        return moment(value).format("DD MMM YYYY");
      },
      shownData() {
        const total = this.limitPerPage*this.currentPage
        return this.totalRecords > total ? total : this.totalRecords
      },
      dataPerPages() {
        const total = Math.ceil(this.totalRecords / this.limitPerPage)
        return total
      },
      onChangePagination(event) {
        this.currentPage = event
        this.getAllAPI()
      },
      getAllAPI(){
        const params = {
          product_type: 'customize-trading',
          limit: this.limitPerPage,
          page: this.currentPage,
          filter: this.search
        }
        PricingsService.getAll(params).then(e => {
          const data = e.data
          this.records = data.pricings
          this.totalRecords = data.count
        })
      }
    },
    components: {
      ArgonPagination,
      ArgonPaginationItem
    },
    mounted() {
      this.getAllAPI()
    },
  };
  </script>
  